/**
 * **Is a movement-reaction decline still in force?** The read side of
 * `activation.moveReactionDeclines` (`projects/overwatch-mid-move.md` Q2 = (ii): a decline holds
 * for the rest of the mover's turn, per watcher). The write side — turning a recorded "decline"
 * answer into a `record_move_reaction_decline` command — is `referee/refereeMove.ts`.
 *
 * Its own module so `checkpointRegistry.ts`'s two compilers carry only a one-line skip each, and
 * so this predicate imports nothing from the registry (no module cycle).
 */
import type { CombatantId, EncounterState } from "@lancer-vtt/domain";

/**
 * Has `watcherId` declined `consumerId`'s offer against `moverId`, with that decline still in
 * force? The checkpoint compilers skip such a watcher. They run this AFTER their own
 * Disengaged/eligibility gates, so a decline never makes an ineligible watcher look eligible.
 */
export function hasLiveMoveReactionDecline(
  state: EncounterState,
  key: { watcherId: CombatantId; moverId: CombatantId; consumerId: string },
): boolean {
  const declines = state.activation.moveReactionDeclines;
  if (declines === undefined) return false;
  return declines.some((d) => d.watcherId === key.watcherId && d.moverId === key.moverId && d.consumerId === key.consumerId);
}
